import type { ICommuterParkingLot } from '../../../models/commuter-parking-lot.model';

export class CommuterParkingLotApiModel {
  public static mapToBusinessModel(apiModel: CommuterParkingLotApiModel): ICommuterParkingLot {
    return {
      name: apiModel.name,
      totalCapacity: apiModel.totalCapacity,
      freeSpaces: apiModel.freeSpaces === null || apiModel.freeSpaces === undefined ? undefined : apiModel.freeSpaces,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
    };
  }

  public name!: string;
  public totalCapacity!: number;
  public freeSpaces?: number;
  public latitude!: number;
  public longitude!: number;
}
